import React, { memo, useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import StatusBar from 'design-system/StatusBar';
import { AppView, rem, Spacer } from 'design-system';
import { floatingButtonArea } from 'design-system/FloatingButton';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import Walkthrough from 'features/feed/components/walkthrough/Walkthrough';
import useWalkthroughLayout from 'features/feed/components/walkthrough/useWalkthroughLayout';
import { useShowWalkthroughV6 } from 'features/feed/components/walkthrough/hooks/useShowWalkthroughV6';
import FloatingSearchButton from './FloatingSearchButton';
import FSCSCompensationInfoView from './FSCSCompensationInfoView';
import SecclInitialScreenTopInfo from './SecclInitialScreenTopInfo';
import SetupInvestmentAccountButton from './SetupInvestmentAccountButton';
import { NavigationHeaderWithAvatarAndHelp } from './NavigationHeaderWithAvatar';
const SecclInitialScreen = () => {
    const showWalkthroughV6 = useShowWalkthroughV6();
    const { itemPositions, scrollHeight, scrollLayoutHeight, onLayout } = useWalkthroughLayout();
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    const handleLayout = useCallback((event) => {
        onLayout('investTabInfo', event);
    }, [onLayout]);
    return (<AppView withFrame={false}>
      <StatusBar animated barStyle="dark-content"/>
      <NavigationHeaderWithAvatarAndHelp showTitle={false}/>
      <View style={[styles.flex, paddingHorizontalStyle]}>
        <View style={styles.topContainer}>
          <View onLayout={handleLayout}>
            <SecclInitialScreenTopInfo />
          </View>
        </View>
        <View style={styles.horizontalPadding}>
          <SetupInvestmentAccountButton brandLight/>
          <Spacer h={16}/>
          <FSCSCompensationInfoView />
        </View>
        <View style={{ height: floatingButtonArea }}/>
        <FloatingSearchButton source="onboarding"/>
      </View>
      {!!showWalkthroughV6 && (<Walkthrough isInTab scrollHeight={scrollHeight} itemPositions={itemPositions} scrollLayoutHeight={scrollLayoutHeight}/>)}
    </AppView>);
};
export default memo(SecclInitialScreen);
const styles = StyleSheet.create({
    horizontalPadding: {
        paddingHorizontal: rem(16),
    },
    topContainer: {
        flex: 1,
        justifyContent: 'center',
    },
    flex: {
        flex: 1,
    },
});
